import IconButton from "@mui/material/IconButton";
import { memo } from "react";

import AppIcon from "@/components/Core/AppIcon";
import Logo from "@/components/Core/Logo";
import { useDeviceType, useTranslate } from "@/hooks";

import { SidebarHeader } from "../styles";

interface SidebarLogoProps {
  toggleDrawer?: () => void;
}

const SidebarLogo = memo(({ toggleDrawer }: SidebarLogoProps) => {
  const { isMobile } = useDeviceType();
  const t = useTranslate();

  return (
    <SidebarHeader>
      {isMobile && (
        <IconButton
          color="inherit"
          onClick={toggleDrawer}
          aria-label={t("common.close")}
          sx={{ position: "absolute", left: 16 }}
        >
          <AppIcon name="close" />
        </IconButton>
      )}
      <Logo fullWidth={isMobile} />
    </SidebarHeader>
  );
});
SidebarLogo.displayName = "SidebarLogo";

export default SidebarLogo;
